import React from 'react';
import { ChevronsLeftIcon, ChevronsRightIcon } from 'lucide-react';
type ChevronHeadingProps = {
  children: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3';
  size?: 'lg' | 'md' | 'sm';
};
const sizes = {
  lg: 'text-4xl md:text-[42px]',
  md: 'text-3xl md:text-[34px]',
  sm: 'text-2xl md:text-[28px]'
};
export function ChevronHeading({
  children,
  as: Tag = 'h2',
  size = 'md'
}: ChevronHeadingProps) {
  return <div className="flex items-center justify-center gap-5" data-id="element-72" data-mp="j1b0dyxdgqjl">
      <ChevronsLeftIcon className="h-7 w-7 shrink-0 text-brand-sky" aria-hidden data-id="element-73" data-mp="o0nv15uhj1wq" />
      <Tag className={`font-condensed font-semibold uppercase tracking-tight text-navy ${sizes[size]}`} data-id="element-74" data-mp="o2qhjfwficwp">{children}</Tag>
      <ChevronsRightIcon className="h-7 w-7 shrink-0 text-brand-sky" aria-hidden data-id="element-75" data-mp="eauia1ilwgqw" />
    </div>;
}